import { dcFactory } from 'dc';
import SimpleFormComponent from './js/simple-form.component';

dcFactory.register(SimpleFormComponent);
